import { CallerMicMutedIcon } from '@rsos/base-assets/icons/src/CallerMicMutedIcon';
import { CallerMicUnmutedIcon } from '@rsos/base-assets/icons/src/CallerMicUnmutedIcon';
import { useDispatcherVideoContext } from '../../DispatcherVideoContext/useDispatcherVideoContext';
import { StyledButton } from './DispatcherControls.styles';

export const MuteCallerButton = () => {
  const { caller, toggleCallerMute } = useDispatcherVideoContext();

  return (
    <StyledButton
      title={caller?.isMicrophoneEnabled ? 'Mute caller' : 'Unmute caller'}
      onClick={toggleCallerMute}
      disabled={!caller}
    >
      {!caller?.isMicrophoneEnabled ? (
        <CallerMicMutedIcon />
      ) : (
        <CallerMicUnmutedIcon />
      )}
    </StyledButton>
  );
};
